import Repository from '@/repositories/repository'

const GlobalSeoRepository = {
  async getAllGlobalSeo(queryParams: any = {}) {
    const params = {
      page: '1',
      page_size: '10',
      ...queryParams
    }

    return await Repository('global', 'page', params)
  }
}

export default GlobalSeoRepository
